import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const PROPERTYTYPEGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PropertyTypeGroup.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PropertyTypeGroup.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
  FieldBuilder
    .text('description', 'Entity.PropertyTypeGroup.Description')
    .minLength(1)
    .maxLength(200)
    .build(),
];

export const PROPERTYTYPEGROUP_CONFIG = {
  entityName: 'PropertyTypeGroup',
  localizationKey: 'Planning::Entity.PropertyTypeGroup',
  fields: PROPERTYTYPEGROUP_FIELDS,
  permission: 'ControllingContract.PropertyTypeGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
